import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Button from '../Button'
import { delSeries } from '../../redux/apiCalls'

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.theme.background}80;
    backdrop-filter: blur(4px);
    z-index: 10;
`
const Modal = styled.div`
    width: 30%;
    border-radius: 14px;
    background-color: ${props => props.theme.background};
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    input { 
        width: 100%;
        padding: 1rem;
        border: 1px solid ${props => props.theme.body};
        background-color: transparent;
        color: ${props => props.theme.text};
        font-size: 16px;
        border-radius: 8px;

        &:focus {
            outline: none;
        }
        
    }
`

const DeleteSeries = ({ id, handleClose }) => {
    const { isFetching, error } = useSelector(state => state.series);
    
    const dispatch = useDispatch();
    const handleSubmit = (id) => {
        delSeries(dispatch, id).then(() => {
            if(!error) {
                handleClose();
            }
        });
        
    }

    return (
        <Backdrop>
            <Modal>
                <div className='flex justify-between items-center text-center'>
                    <h1>Delete This Series?</h1>
                </div>
                <div className='flex gap-x-8'>
                    {
                        isFetching ?
                        <Button text='Deleting..' disabled={true}/>
                        :
                        <Button text='Delete' disabled={false} onClick={() => handleSubmit(id)}/>
                        
                    }
                    <Button text='Cancel' onClick={handleClose} />
                </div>
            </Modal>
            <ToastContainer 
                autoClose={5000} 
                position="top-center"
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Backdrop>
    )
}

export default DeleteSeries